import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { Translation } from "react-i18next";
import Slide from '@mui/material/Slide';
import { Box, Card, CardActions, CardContent, Divider, CardHeader, CardActionArea } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export function getTransI18N(varKey) {
  return <Translation>{(t, { i18n }) => <span>{t(`others.enum_${varKey}`)}</span>}</Translation>;
};

export const ConfirmContext = createContext({
  confirm: () => Promise.reject(new Error('Rejection reason')),
});

ConfirmContext.propTypes = {
    confirm: (result) => Promise.resolve(false),
};

export const Transition = React.forwardRef(function Transition(
  props,
  ref,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const numberToStringFormat = (num) => {
  if (num === undefined || num === null || num === '') return 0;
  if(typeof(num) === 'string') {
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else if(typeof(num) === 'number') {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

export const numberCheck = (v) => {
  let num = v || 0
  if (!isFinite(num)) return
  num = num.toString()

  if (num !== '0' &&  !num.includes('.')) {
    num = num.replace(/^0+/,'')
  }
  return num;
};

/// 사용자 비교를 위해서 사용
export const UserType2Value = (usertype) => {
  let val = 0;
  if(usertype === "system") val = 7;
  else if(usertype === "master") val = 5;
  else if(usertype === "basic") val = 1;
  return val;
};

export const CheckIsWriter = (auth, createBy) => {
  if (auth === undefined || auth === null || auth.userId === null || auth.userId === '') return false;
  if (!createBy) return false;
  
  return auth?.userId ? auth.userId === createBy : false;
};

export const GridContainer = (props) => {
  const { children, sx, ...other } = props;
  return (
    <Grid container alignItems="center" spacing={1} sx={[ (theme) => ({  '--Grid-borderWidth': '1px',
                                                                            borderColor: 'divider',
                                                                            '& > div.divline': {
                                                                                borderTop: 'var(--Grid-borderWidth) dotted',
                                                                                borderColor: 'divider',
                                                                                lineHeight: '3px',
                                                                                height: '3px',
                                                                            },
                                                                      }), ...(Array.isArray(sx) ? sx : [sx]), 
                                                        ]} {...other}
    >
      {children}
    </Grid>
  );
};
GridContainer.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

export const Item = (props) => {
    const { sx, ...other } = props;
    return (
        <Box sx={[ (theme) => ({p: 1, m: 1, bgcolor: 'grey.100', color: 'grey.800', 
                                border: '1px solid',  borderColor: 'grey.300', borderRadius: 2, 
                                fontSize: '0.875rem', fontWeight: '700',
                              ...theme.applyStyles('dark', {
                                    bgcolor: '#101010',
                                    color: 'grey.300',
                                    borderColor: 'grey.800',
                                }),
                }),
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...other}
        />
    );
};
Item.propTypes = {
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(
            PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
        ),
        PropTypes.func,
        PropTypes.object,
    ]),
};

export const CardItem = (props) => {
  const { title, children, iconFontAwesome, actionChildren } = props;
  return (
    <Card item size={{ xs: 12, sm: 12, md: 12 }} sx={{ p: 0, m: 0, justifyItems: "center", width: "100%", boxShadow: "none", }}>
      <CardActionArea sx={{ height: "100%", width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", }}>
        
      {title ?
      <CardHeader avatar={iconFontAwesome ? <FontAwesomeIcon icon={iconFontAwesome} size="lg" style={{ paddingLeft: '5px', paddingRight: '0px', color: '#03124f' }} /> : null}
                  sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%", p: 1, }}
                  titleTypographyProps={{ variant: "h5", component: "h5", sx: { fontWeight: "bold", textAlign: "left", display: "inline-block", width: "100%", } }}
                  title={title} /> : null}

      <CardContent sx={{ display: "inline-block", alignItems: "center", justifyContent: "center", justifyItems: "center", width: "100%", p: 1, }}>
        {children}
      </CardContent>

      {actionChildren ?
      <CardActions disableSpacing>
        {actionChildren}
      </CardActions> : null}

      </CardActionArea>
    </Card>
  );
}
CardItem.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  iconFontAwesome: PropTypes.object,
  actionChildren: PropTypes.node,
};

export const Line = (props) => {
    const { sx, ...other } = props;
    return (
        <Divider sx={[ (theme) => ({ my: 1, borderStyle: "dotted", borderColor: '#E46C0A'}),
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...other}
        />
    );
};
Line.propTypes = {
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(
            PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
        ),
        PropTypes.func,
        PropTypes.object,
    ]),
}

/*
* 게시판 유형 정보
*/
export const BoardType = [
    {
        name: getTransI18N("board"),
        value: "board",
    },
    {
        name: getTransI18N("faq"),
        value: "faq",
    },
    {
        name: getTransI18N("qna"),
        value: "qna",
    }
];

/* *사용자 구분 */
export const UserType = [
  {
    name: getTransI18N("system"),
    value: "system"
  },
  {
    name: getTransI18N("master"),
    value: "master"
  },
  {
    name: getTransI18N("basic"),
    value: "basic"
  }
];

/* *사용 구분 */
export const UseYn = [
  {
    name: getTransI18N("Y"),
    value: "Y"
  },
  {
    name: getTransI18N("N"),
    value: "N"
  }
];

/* *언어 선택 */
export const languages = [
  { code: 'ko', name: '한국어', flag: 'kr' }, // 한국어
  { code: 'en', name: 'English', flag: 'us' }, // 영어
  { code: 'fr', name: 'Français', flag: 'fr' }, // 프랑스어
  { code: 'de', name: 'Deutsch', flag: 'de' }, // 독일어
  { code: 'zh', name: '中文(简体)', flag: 'cn' }, // 중국어(간체)
  { code: 'zh-TW', name: '中文(繁體)', flag: 'tw' }, // 중국어(번체, 대만)
  { code: 'ja', name: '日本語', flag: 'jp' }, // 일본어
  { code: 'es', name: 'Español', flag: 'es' }, // 스페인어
  { code: 'ru', name: 'Русский', flag: 'ru' }, // 러시아어
  { code: 'it', name: 'Italiano', flag: 'it' }, // 이탈리아어
  { code: 'pt', name: 'Português', flag: 'pt' }, // 포르투갈어
  { code: 'pt-BR', name: 'Português (BR)', flag: 'br' }, // 포르투갈어 (브라질)
  { code: 'ar', name: 'العربية', flag: 'sa' }, // 아랍어
  { code: 'hi', name: 'हिन्दी', flag: 'in' }, // 힌디어
  { code: 'th', name: 'ไทย', flag: 'th' }, // 태국어
  { code: 'tr', name: 'Türkçe', flag: 'tr' }, // 터키어
  { code: 'el', name: 'Ελληνικά', flag: 'gr' }, // 그리스어
  { code: 'vi', name: 'Tiếng Việt', flag: 'vn' }, // 베트남어
  { code: 'ms', name: 'Bahasa Melayu', flag: 'my' }, // 말레이어
  { code: 'bn', name: 'বাংলা', flag: 'bd' }, // 벵골어
  { code: 'sv', name: 'Svenska', flag: 'se' }, // 스웨덴어
  { code: 'no', name: 'Norsk', flag: 'no' }, // 노르웨이어
  { code: 'fi', name: 'Suomi', flag: 'fi' }, // 핀란드어
  { code: 'da', name: 'Dansk', flag: 'dk' }, // 덴마크어
  { code: 'nl', name: 'Nederlands', flag: 'nl' }, // 네덜란드어
  { code: 'pl', name: 'Polski', flag: 'pl' }, // 폴란드어
  { code: 'cs', name: 'Čeština', flag: 'cz' }, // 체코어
  { code: 'hu', name: 'Magyar', flag: 'hu' }, // 헝가리어
  { code: 'ro', name: 'Română', flag: 'ro' }, // 루마니아어
  { code: 'sk', name: 'Slovenčina', flag: 'sk' }, // 슬로바키아어
  { code: 'bg', name: 'Български', flag: 'bg' }, // 불가리아어
  { code: 'hr', name: 'Hrvatski', flag: 'hr' }, // 크로아티아어
  { code: 'uk', name: 'Українська', flag: 'ua' }, // 우크라이나어
  { code: 'he', name: 'עברית', flag: 'il' }, // 히브리어
  { code: 'fa', name: 'فارسی', flag: 'ir' }, // 페르시아어
  { code: 'sw', name: 'Kiswahili', flag: 'ke' }, // 스와힐리어
  { code: 'tl', name: 'Tagalog', flag: 'ph' }, // 타갈로그어
  { code: 'ur', name: 'اردو', flag: 'pk' }, // 우르두어
  { code: 'am', name: 'አማርኛ', flag: 'et' }, // 암하라어
  { code: 'az', name: 'Azərbaycan', flag: 'az' }, // 아제르바이잔어
  { code: 'kk', name: 'Қазақ тілі', flag: 'kz' }, // 카자흐어
  { code: 'uz', name: 'Oʻzbekcha', flag: 'uz' }, // 우즈베크어
  { code: 'ka', name: 'ქართული', flag: 'ge' }, // 그루지야어 (조지아)
  { code: 'pa', name: 'ਪੰਜਾਬੀ', flag: 'in' }, // 펀자브어 (인도)
  { code: 'mr', name: 'मराठी', flag: 'in' }, // 마라티어 (인도)
  { code: 'ta', name: 'தமிழ்', flag: 'in' }, // 타밀어 (인도)
  { code: 'te', name: 'తెలుగు', flag: 'in' }, // 텔루구어 (인도)
  { code: 'kn', name: 'ಕನ್ನಡ', flag: 'in' }, // 칸나다어 (인도)
  { code: 'ml', name: 'മലയാളം', flag: 'in' }, // 말라얄람어 (인도)
  { code: 'si', name: 'සිංහල', flag: 'lk' }, // 싱할라어 (스리랑카)
  { code: 'my', name: 'မြန်မာ', flag: 'mm' }, // 미얀마어
  { code: 'km', name: 'ភាសាខ្មែរ', flag: 'kh' }, // 크메르어 (캄보디아)
  { code: 'lo', name: 'ລາວ', flag: 'la' }, // 라오스어
  { code: 'mn', name: 'Монгол', flag: 'mn' }, // 몽골어
  { code: 'ne', name: 'नेपाली', flag: 'np' }, // 네팔어
  { code: 'tg', name: 'Тоҷикӣ', flag: 'tj' }, // 타지크어
  { code: 'ps', name: 'پښتو', flag: 'af' }, // 파슈토어 (아프가니스탄)
  { code: 'sq', name: 'Shqip', flag: 'al' }, // 알바니아어
  { code: 'hy', name: 'Հայերեն', flag: 'am' }, // 아르메니아어
];